<template>
    <section>
        <div class="order-info-container">
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.type.label }}</span>
                    <span v-if="payload.type.required" class="required-field-indicator" title="Campo obrigatório">*</span>
                </div>
                <select class="form-control" v-model="payload.type.value">
                    <option value="" selected disabled>⬇ Selecione um item</option>
                    <option value="Malote P">Malote P</option>
                    <option value="Malote M">Malote M</option>
                    <option value="Malote G">Malote G</option>
                    <option value="Bananinha">Bananinha</option>
                    <option value="GTV">GTV</option>
                    <option value="Tabela de Senhas">Tabela de Senhas</option>
                </select>
            </div>
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.quantity.label }}</span>
                    <span v-if="payload.quantity.required" class="required-field-indicator" title="Campo obrigatório">*</span>
                </div>
                <input class="form-control" type="number" v-model="payload.quantity.value" placeholder="Quantidade" min="1" :max="payload.type.value == 'Tabela de Senhas' ? 5 : 999">
            </div>
            <div class="custom-input-group">
                <button class="form-control" id="add-order-button" @click="addItem">
                    <i class="fas fa-plus"></i> Adicionar item
                </button>
            </div>
        </div>
        <div class="description-container">
            <div class="order-review-container">
                <span id="order-review-title">Resumo do Pedido</span>
                <div  v-if="payload.orderReview.value.length"  class="order-review-container-list">
                    <div v-for="item in payload.orderReview.value" :key="item.id">
                        <span>{{ item.type }} - {{ item.quantity }}</span>
                        <button class="form-control" id="remove-order-button" @click="removeItem(item.id)"><i class="fas fa-trash"></i></button>
                        <button class="form-control" id="edit-order-button" @click="editItem(item.id)"><i class="fas fa-pencil-alt"></i></button>
                    </div>
                </div>
                <div v-else class="order-review-container-empty">
                    <span>Não há itens neste pedido, adicione pelo menos um item</span>
                </div>
            </div>
            <div class="custom-input-group">
                <div>
                    <span>{{ payload.description.label }}</span>
                    <span v-if="payload.description.required" class="required-field-indicator" title="Campo obrigatório">*</span>
                </div>
                <textarea class="form-control" rows="10" placeholder="Descreva..." v-model="payload.description.value"></textarea>
            </div>
        </div>
        <div class="buttons-container">
            <button class="form-control" id="cancel-button" @click="cancel"><i class="fas fa-times"></i>  Descartar</button>
            <button v-if="!saving" class="form-control" id="save-button" @click="save"><i class="fas fa-save"></i>  Salvar</button>
            <button v-else class="form-control" id="save-button" disabled><i class="fas fa-spinner fa-pulse"></i>  Salvando...</button>
        </div>
    </section>
</template>

<script>
export default {
    directives: {},
    props: ['clientInfo', 'saveLoading', 'reset'],
    components: {},
    data(){
        return {
            saving: false,
            payload: {
                description: {label: 'Observação', value: '', required: false},
                type: {label: 'Tipo', value: '', required: false},
                quantity: {label: 'Quantidade', value: '', required: false},
                orderReview: {label: 'Resumo do pedido', value: [], required: false}
            },
        }
    },
    computed: {},
    created(){},
    mounted(){},
    methods: {
        generateUniqueId() {
            return 'id-' + Date.now().toString(36) + '-' + Math.random().toString(36).substr(2, 9);
        },
        addItem(){
            if(!this.payload.type.value || !this.payload.quantity.value){
                Swal.fire('Item inválido', 'Por favor, selecione um item e uma quantidade válida para adicionar ao pedido!', 'error')
                return
            }
            if(this.payload.type.value === 'Tabela de Senhas' && this.payload.quantity.value > 5){
                Swal.fire('Quantidade inválida', 'A quantidade máxima para Tabela de Senhas é 5!', 'error')
                return
            }
            if(!this.payload.orderReview.value.some(el => el.type === this.payload.type.value)){
                this.payload.orderReview.value.push({
                    id: this.generateUniqueId(),
                    type: this.payload.type.value,
                    quantity: this.payload.quantity.value
                })
                this.payload.type.value = ''
                this.payload.quantity.value = ''
            } else {
                Swal.fire('Item já adicionado', 'O item selecionado já foi adicionado ao pedido. Caso queira alterar a quantidade, edite o item no Resumo do Pedido!', 'warning')
            }
        },
        removeItem(id){
            this.payload.orderReview.value = this.payload.orderReview.value.filter(item => item.id !== id)
        },
        editItem(id){
            this.payload.type.value = this.payload.orderReview.value.find(item => item.id === id).type
            this.payload.quantity.value = this.payload.orderReview.value.find(item => item.id === id).quantity
            this.payload.orderReview.value = this.payload.orderReview.value.filter(item => item.id !== id)
        },
        async save(){
            this.$emit('save', {type: 'elogio', data: this.payload})
        },
        async cancel(){
            Swal.fire({
                title: 'Descartar solicitação?',
                html: 'Deseja descartar as alterações feitas?',
                showCancelButton: true,
                confirmButtonText: 'Sim, descartar',
                cancelButtonText: 'Não, continuar editando',
                type: "question",
                showCloseButton: true,
                reverseButtons: true
            }).then(async result => {
                if(result.value) {
                    this.$emit('cancel')
                    await this.resetForm()
                }
            });
        },
        async resetForm(){
            this.payload = {
                description: {label: 'Observação', value: '', required: false},
                type: {label: 'Tipo', value: '', required: false},
                quantity: {label: 'Quantidade', value: '', required: false},
                orderReview: {label: 'Resumo do pedido', value: [], required: true}
            }
        }
    },
    watch: {
        'payload.type.value'(value){
            if(value === 'Tabela de Senhas' && this.payload.quantity.value > 5){
                this.payload.quantity.value = 5
            }
        },
        'payload.quantity.value'(value){
            if(this.payload.type.value === 'Tabela de Senhas' && value > 5){
                this.payload.quantity.value = 5
            }
        },
        saveLoading: {
            handler(value){
                this.saving = value
            }
        },
        reset() {
            this.resetForm()
        }
    }
}
</script>

<style lang="scss" scoped>
.required-field-indicator {
    font-size: small;
    text-align: start;
    color: red;
}
.custom-input-group {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: start;
    width: 100%;
    justify-content: flex-end;

    span {
        font-weight: bold;
    }

    textarea {
        resize: none
    }

    .input-with-button {
        display: flex;
        gap: 5px;
        height: 100%;
        align-items: center;

        button {
            border-radius: 10px !important;
            box-shadow: none;
        }
    }
}

.buttons-container {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    margin-bottom: 0;
    margin-top: 10px;

    button {
        width: fit-content;
        color: white;
        border-radius: 10px !important;
        box-shadow: none;
        transition: ease-in-out 0.2s
    }

    #save-button {
        background-color: darkgreen;

        &:hover {
            background-color: #023b02;
        }
    }

    #cancel-button {
        background-color: #a00404;

        &:hover {
            background-color: #6d0303;
        }
    }
}

.order-info-container {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin: 10px;
}

.order-review-container{
    flex: 1;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    border-radius: 10px;
    min-height: 270px;

    #order-review-title {
        font-size: medium;
        font-weight: bold;
        text-align: center;
        padding: 10px;
    }

    &-list {
        display: flex;
        flex-direction: column;

        div {
            display: flex;
            gap: 10px;
            align-items: center;
            justify-content: space-between;
            border-top: 1px solid #ccc;
            padding: 10px;

            span {
                flex: 2;
                font-weight: bold;
            }

            button {
                width: fit-content;
                height: fit-content;
                border: none;
                background: none;
                padding: 0;
            }

            #edit-order-button {
                color: cornflowerblue;
            }

            #remove-order-button {
                color: firebrick;
            }
        }
    }

    &-empty {
        padding: 5px;
        text-align: center;
    }
}

.description-container {
    margin: 10px;
    display: flex;
    gap: 10px;
    align-items: flex-start;
}

#add-order-button {
    background-color: #1c869a;
    color: white;
    border-radius: 10px !important;
}
</style>